export function IconGithub() {
  return (
    <svg viewBox="0 0 1024 1024" fill="currentColor" height="1em" width="1em">
      <path d="M511.6 76.3C264.3 76.2 64 276.4 64 523.5 64 718.9 189.3 885 363.8 946c23.5 5.9 19.9-10.8 
      19.9-22.2v-77.5c-135.7 15.9-141.2-73.9-150.3-88.9C215 726 171.5 718 184.5 703c30.9-15.9 62.4 4 
      98.9 57.9 26.4 39.1 77.9 32.5 104 26 5.7-23.5 17.9-44.5 34.7-60.8-140.6-25.2-199.2-111-199.2-213 
      0-49.5 16.3-95 48.3-131.7-20.4-60.5 1.9-112.3 4.9-120 58.1-5.2 118.5 41.6 123.2 45.3 33-8.9 
      70.7-13.6 112.9-13.6 42.4 0 80.2 4.9 113.5 13.9 11.3-8.6 67.3-48.8 121.3-43.9 2.9 7.7 24.7 58.3 
      5.5 118 32.4 36.8 48.9 82.7 48.9 132.3 0 102.2-59 188.1-200 212.9a127.5 127.5 0 0138.1 91v112.5c.8 
      9 0 17.9 15 17.9 177.1-59.7 304.6-227 304.6-424.1 0-247.2-200.4-447.3-447.5-447.3z" />
    </svg>
  );
}

export function IconGoogle() {
  return (<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M4 3.71v16.58a.7 .7 0 0 0 1.05 .606l14.622 -8.42a.55 .55 0 0 0 0 -.953l-14.622 -8.419a.7 .7 0 0 0 -1.05 .607z" /><path d="M15 9l-10.5 11.5" /><path d="M4.5 3.5l10.5 11.5" /></svg>)
}

export function IconArrowBack(props) {
  return (
    <svg className="invertx" viewBox="0 0 512 512" fill="currentColor" height="1em" width="1em" {...props}>
      <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={80}
        d="M244 400L100 256l144-144M120 256h292" /></svg>
  );
}

export function IconBxsHandUp(props) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" height="1em" width="1em" {...props}>
      <path d="M19.221 10.803L12 10V4a2 2 0 00-4 0v12l-3.031-1.212a2 2 0 00-2.64 1.225l-.113.34a.998.998 
      0 00.309 1.084l5.197 4.332c.179.149.406.231.64.231H19a2 2 0 002-2v-7.21a2 2 0 00-1.779-1.987z" />
    </svg>
  );
}

export function IconAsterisk(props) {
  return (
    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
      strokeWidth={4} viewBox="0 0 24 24" height="1em" width="1em" {...props}>
      <path d="M12 6v12M17.196 9L6.804 15M6.804 9l10.392 6" />
    </svg>
  );
}

export function IconBxsLockAlt(props) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" height="1em" width="1em" {...props}>
      <path d="M20 12c0-1.103-.897-2-2-2h-1V7c0-2.757-2.243-5-5-5S7 4.243 7 7v3H6c-1.103 0-2 .897-2 
      2v8c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-8zM9 7c0-1.654 1.346-3 3-3s3 1.346 3 3v3H9V7z" />
    </svg>
  );
}

export function IconArrowRight() {
  return (
    <svg className="dark:invert" viewBox="0 0 16 16" height="50px" width="50px"
      fill="none" strokeLinecap="round" strokeLinejoin="round">
      <path strokeWidth="3" stroke="rgb(0 0 0/0.1)" d="M4 8 L 12 8 l-2 2 m2 -2 l-2 -2" />
      <path strokeWidth="2" stroke="white" d="M4 8 L 12 8 l-2 2 m2 -2 l-2 -2" />
    </svg>
  );
}

export function IconStar(props) {
  return (
    <svg viewBox="0 0 1024 1024" fill="currentColor" height="50px" width="50px" {...props}>
      <path d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 
      14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 00.6 45.3l183.7 179.1-43.4 
      252.9a31.95 31.95 0 0046.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 
      26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z" />
    </svg>
  );
}

export function IconUndo(props) {
  return (
    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
      strokeWidth={2} viewBox="0 0 24 24" height="1em" width="1em" {...props}>
      <path d="M3 7v6h6" />
      <path d="M21 17a9 9 0 00-9-9 9 9 0 00-6 2.3L3 13" />
    </svg>
  );
}

export function IconRedo(props) {
  return (
    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
      strokeWidth={2} viewBox="0 0 24 24" height="1em" width="1em" {...props}>
      <path d="M21 7v6h-6" />
      <path d="M3 17a9 9 0 019-9 9 9 0 016 2.3l3 2.7" />
    </svg>
  );
}

export function IconSkip(props) {
  return (
    <svg height="1em" width="1em" viewBox="0 0 24 24"
      stroke="currentColor" strokeWidth="3" fill="none"
      strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0 -18" /><path d="M16 12l-4 -4" /><path d="M16 12h-8" /><path d="M12 16l4 -4" />
    </svg>
  )
}

export function IconShowAd(props) {
  return (
    <svg height="1em" width="1em" viewBox="0 0 24 24"
      stroke="currentColor" strokeWidth="3" fill="none"
      strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M12 6h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-6" />
      <path d="M11 13l9 -9" /><path d="M15 4h5v5" />
    </svg>
  )
}

export function IconLoader() {
  return <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M12 6l0 -3" /><path d="M16.25 7.75l2.15 -2.15" /><path d="M18 12l3 0" /><path d="M16.25 16.25l2.15 2.15" /><path d="M12 18l0 3" /><path d="M7.75 16.25l-2.15 2.15" /><path d="M6 12l-3 0" /><path d="M7.75 7.75l-2.15 -2.15" /></svg>
}